<!-- =========================================================================================
  File Name: UpSell.vue
  Description: UpSell products upon checkout
  ----------------------------------------------------------------------------------------
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->


<template>
  <vs-popup fullscreen :active.sync="isUpSellActiveLocal" title="Agrega a tu orden">
    <div class="items-grid-view vx-row match-height">
      <div class="vx-col w-full sm:w-1/2 lg:w-1/5" v-for="item in options" :key="item.id">
        <item-grid-view :item="item">
          <!-- SLOT: ACTION BUTTONS -->
          <template slot="action-buttons">
            <div class="flex flex-wrap">

              <!-- PRIMARY BUTTON: ADD TO WISH LIST -->
              <div class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer">
                <span class="text-xl font-bold ml-2">Q{{ item.price.toFixed(2) }}</span>
              </div>

              <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
              <div v-if="isInCart(item.id)" class="item-view-secondary-action-btn bg-success p-3 flex flex-grow items-center justify-center text-white">
                <feather-icon icon="CheckIcon" svgClasses="h-4 w-4"/>
                <span class="text-sm font-semibold ml-2">Ya está en el carrito</span>
              </div>
              <div v-else class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer" @click="cartButtonClicked(item)">
                <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4"/>
                <span class="text-sm font-semibold ml-2">AGREGAR</span>
              </div>
            </div>
          </template>
        </item-grid-view>
      </div>
    </div>
    <vs-button color="success" class="mr-4" @click="isUpSellActiveLocal = false">Continuar</vs-button>
    <vs-button color="danger" size="small" type="flat" @click="isUpSellActiveLocal = false">No gracias</vs-button>
  </vs-popup>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  const ItemGridView = () => import('./ItemGridView.vue');

  export default {
    props: {
      product: null,
      isUpSellActive: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        loaded: false,
        title: '',
        products: [],
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    components: {
      VuePerfectScrollbar,
      ItemGridView
    },
    computed: {
      stockAPI() {
        return this.$store.getters['getParameter']('stock').stockAPI;
      },
      selectedStore() {
        return this.$store.state.selectedStore;
      },
      isUpSellActiveLocal: {
        get() {
          return this.isUpSellActive
        },
        set(val) {
          if (!val) {
            this.$emit('close');
          }
        }
      },
      options() {
        let products = [];
        if (this.product) {
          if (this.product.hasOwnProperty('upsell')) {
            products = this.$store.getters['products'].filter(item => this.product.upsell.split(',').includes(item.id.toString()));
          }
        }
        return products;
      },
      isInCart() {
        return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
      },
      productGroups() {
        return this.$store.state.productGroups.list;
      }
    },
    methods: {
      cartButtonClickedBak(item) {
        this.$store.dispatch('eCommerce/additemInCart', {...item, cartQuantity: 1, productGroups: this.productGroups});
        this.$vs.notify({
          title: 'Información',
          text: `Se agregó el producto ${item.name} a la orden`,
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-info'
        })
      },
      async cartButtonClicked(item) {
        let available = false;
        if (item.hasOwnProperty('stockId')) {
          this.$vs.loading({
            text: `Validando existencia de ${item.name}, espera por favor`,
            type: 'point'
          });
          const response = await this.$http.post(`${this.stockAPI}/stock/product`, {
            storeID: this.selectedStore.stockId,
            productID: parseInt(item.stockId)
          });
          if (response) {
            if (response.data) {
              available = (response.data.data[0].stock > 1);
            } else {
              available = false;
            }
          } else {
            available = false;
          }
          this.$vs.loading.close();
        } else {
          available = false;
        }
        if (available) {
          this.$store.dispatch('eCommerce/additemInCart', {...item, cartQuantity: 1, productGroups: this.productGroups});
          window.fbq('track', 'AddToCart');
        } else {
          this.$vs.notify({
            title: '¡Lo sentimos!',
            text: `No tenemos disponibilidad de ${item.name} en ${this.selectedStore.name}`,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          });
        }
      },
      checkOut() {
        this.isUpSellActiveLocal = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    .vs-sidebar--background {
      z-index: 52010;
    }

    .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
